import { SwotEnum } from '../../utils/enums/swot';
import './styles.css'

const PerformanceTable = (props: any) => {

  const CircularProgress = ({ percentage, swotType }: any) => {

    // console.log("Percentage",percentage)
    // console.log("Percentage",swotType)
    const circumference = 2 * Math.PI * 20;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;
    const progressClass = `circular-progress ${swotType.toLowerCase()}`;

    return (
      <div className="progress-wrapper">
        <svg className="circular-progress-svg">
          <circle
            cx="24"
            cy="24"
            r="20"
            className="progress-background"
          />
          <circle
            cx="24"
            cy="24"
            r="20"
            className={progressClass}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset
            }}
          />
        </svg>
        <span className={"progress-text " + progressClass}>{percentage}</span>
      </div>
    );
  };

  const getSwotText = (swot: string) => {
    switch (swot) {
      case SwotEnum.STRENGTH:
        return "STRENGTH";
      case SwotEnum.WEAKNESS:
        return "WEAKNESS";
      case SwotEnum.OPPORTUNITY:
        return "OPPORTUNITY";
      case SwotEnum.THREAT:
        return "THREAT";
      default:
        return "";
    }
  }

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <table className="performance-table">
          <thead>
            <tr>
              <th className="col-name">Topic Name</th>
              <th>Marks</th>
              <th>SWOT</th>
              <th className='col-mobile-hidden'>Attempt</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map((row: any, index: any) => (
              <tr key={index}>
                <td className="col-name">{row.topic}</td>
                <td>{row.achieved} / {row.total}</td>
                <td >
                  <span className={`swot-badge ${row.swot.toLowerCase()}`}>
                    {getSwotText(row.swot)}
                  </span>
                </td>
                <td className='col-mobile-hidden'>
                  <CircularProgress percentage={row.attempt} swotType={row.swot} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PerformanceTable;